import { render, staticRenderFns } from "./FormCommonConfig.vue?vue&type=template&id=6d9ec9ef&scoped=true"
import script from "./FormCommonConfig.vue?vue&type=script&lang=js"
export * from "./FormCommonConfig.vue?vue&type=script&lang=js"
import style0 from "./FormCommonConfig.vue?vue&type=style&index=0&id=6d9ec9ef&prod&lang=scss&scoped=true"
import style1 from "./FormCommonConfig.vue?vue&type=style&index=1&id=6d9ec9ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ec9ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCarousel,VCarouselItem,VFlex,VForm,VTab,VTabs,VTextField})
